import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const ContentNotFound = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    height: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '10%',
    gap: '10px'
}))
export const ImageNotFound = styled('img')(({ theme }) => (props) => ({
    width: '15vw',
    [theme.breakpoints.down('lg')]: {
        width: '18vw',
    },
    [theme.breakpoints.down('sm')]: {
        width: '180px',
        height: '180px'
    }
}))
export const TextMassage = styled('h5')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '29px',
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    margin: '8px 16px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        margin: '0 8px',

    }

}))
export const TextLink = styled(Link)(({ theme }) => (props) => ({
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '29px',
    letterSpacing: '0em',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px'
    }
}))
